const updatesAndInsights = ( $ ) => {
	const loadMoreBtn = $( '.load-more' );
	const insightsItems = $( '.insights-items' );
	const insightsDate  = $('.insights-item:not(:first-child)');
	$(window).width() >= 768 && insightsDate.each(function(){
        const date = $(this).find('.date');
        $(this).prepend(date);
    });
	if ( ! loadMoreBtn.length ) {
		return;
	}

	let page = 1;
	const maxPages = loadMoreBtn.data( 'max-pages' );

	loadMoreBtn.on( 'click', function( e ) {
		e.preventDefault();

		if ( page >= maxPages ) {
			return;
		}

		page++;

		const href = window.location.href;
		const ajaxUrl = href.includes( '?' ) ? `${href}&paged=${page}` : `${href}page/${page}/`;

		$.ajax( {
			url: ajaxUrl,
			type: 'GET',
			beforeSend: function() {
				loadMoreBtn.text( 'LOADING...' );
			},
			success: function( data ) {
				const newItems = $( data ).find( '.insights-items' ).html();
				insightsItems.append( newItems );

				if ( page >= maxPages ) {
					loadMoreBtn.remove();
				} else {
					loadMoreBtn.text( 'LOAD MORE' );
				}
			},
			error: function() {
				loadMoreBtn.text( 'ERROR' );
			}
		} );
	} );
};

export default ( ( $ ) => $( updatesAndInsights ) )( jQuery );
